module.exports = __webpack_public_path__ + "img/chinesecompany53.cfca8bde.png";